<template>
    <div v-if='this.users' ref="container" class="">
        <div class="p-1">
            <header class="text-center">
                <div class="header-icon header-icon--calendar"></div>
                <!-- <img src="img/egl/calendar-standard3.svg" alt="calendar icon" class="header-icon"> -->
                <h1 class="h2">{{ $t('translations.when_is_your_GP_working')}}</h1>
                <!-- <p>{{ $t('translations.it_helps_us_if_you_send_your_request_on_the_same_day')}}</p> -->
            </header>

            <div class="container text-center">
                <div class="form-group">
                    <label for="select_site">{{ $t('translations.select_site')}}</label>
                    <select v-model='site_id' class="form-control" id="select_site">
                        <option value=''>{{ $t('translations.all_sites')}}</option>
                        <option v-for='site in $root.provider.site' :key='site.id' :value='site.id'>{{site.name}}</option>
                    </select>
                </div>
            </div>

            <table class="table staff-availability">
                <thead>
                    <tr>
                        <th></th>
                        <th :key='index' v-for='(date, index) in calendar_dates' scope="col" class="text-center">{{date.format("ddd")}}<small>{{date.format("DD/MM")}}</small></th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for='(user) in filtered_users'>
                        <tr :key='user.id'>
                            <th class="" scope="row">{{formatNameWithTitle(user)}}</th>
                            <!-- <th class="" scope="row">{{formatClinician(user)}}</th> -->
                            <td :key='"" + user.id + ":" + index' v-for='(date, index) in calendar_dates' scope="col">
                                <span :class="getAvailability(user, date)[0] == 'Unavailable' ? 'unavailable' : 'available'"></span>
                                <div :key='"" + user.id + ":" + index + ":" + tindex' style='white-space: nowrap' class="time-available" v-for='(time, tindex) in getAvailability(user, date)'>{{time}}</div>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
        <footer class="container mt-2">
            <!-- <router-link :to="{name: 'Profile'}" class="btn btn-round btn-primary-outline btn-block">Back</router-link> -->
            <div @click="$router.go(-1)" class="btn btn-round btn-primary btn-block">{{ $t('translations.back')}}</div>
        </footer>
    </div>
</template>

<script>
export default {
    props: [
        'id'
    ],
    data: function(){
        return {
            calendar_dates: [],
            site_id: "",
            users: this.$root.lookup.staff,
            show: true,
            errors: [],
            test: null
        };
    },
    watch: {
        site_id: function() {
            this.getData(true);
        },
        site_id(selectedSite) {
            localStorage.site_id = selectedSite;
        }
    },
    computed: {
        filtered_users() {
            var filteredUsers = this.users.filter(staff => {
                return this.site_id == "" || this.userHasSiteAvailability(staff, this.site_id);
            });

            filteredUsers.sort((staff1, staff2) => {
                return this.formatSurname(staff1).localeCompare(this.formatSurname(staff2));
                var site1 = this.$root.provider.site.find(site => {return staff1.site_id == site.id});
                var site2 = this.$root.provider.site.find(site => {return staff2.site_id == site.id});
                if(typeof site1 != "undefined" && typeof site2 != "undefined") {
                    if(site1.name == site2.name) {
                        return this.formatSurname(staff1).localeCompare(this.formatSurname(staff2));
                    }
                    return site1.name.localeCompare(site2.name);
                }
                if(typeof site1 == "undefined" && typeof site2 == "undefined") {
                    return this.formatSurname(staff1).localeCompare(this.formatSurname(staff2));
                }
                if(typeof site1 == "undefined") {
                    return 1;
                }
                if(typeof site2 == "undefined") {
                    return -1;
                }
            });
            return filteredUsers;
        }
    },
    mounted() {
        for(var dayLoop = 0; dayLoop < 7 && this.calendar_dates.length < 5; dayLoop++) {
            var date = this.moment().add(dayLoop, 'days');
            var weekday = date.isoWeekday();
            if(weekday < 6) {
                this.calendar_dates.push(this.moment().add(dayLoop, 'days'));
            }
        }
        //this.test = this.getAvailability(this.users[2], this.moment());
    },
    methods: {
        getAvailability(user, date) {
            var dayName = date.format("dddd").toLowerCase();
            var isoWeekday = date.isoWeekday();
            var day = date.format("YYYY-MM-DD");

            var times = [];

            if(Array.isArray(user.availability_date) && user.availability_date.length) {
                var availability_dates = user.availability_date.filter(obj => {return obj.date_to ? (obj.date_from <= day && obj.date_to >= day) : (obj.date_from == day) });
                if(!availability_dates.length) {
                    availability_dates = user.availability_date.filter(obj => {return obj.day_of_week == isoWeekday});
                }
                for(var dayIndex in availability_dates) {
                    // This is crazy code to fix Safari on iOS 9.3 which mistakenly considers
                    // this property to by an object. It isn't. Wrappin git in Object.keys fixes it
                    // but obfuscates the code slightly.
                    for(var index in Object.keys(availability_dates[dayIndex].availability_time)) {
                        var time = this.getTimeRange(availability_dates[dayIndex].availability_time[index]);
                        if(time && (this.site_id == "" || availability_dates[dayIndex].availability_time[index].site_id == this.site_id)) {
                            times.push(time);
                        }
                    }
                }
                if(times.length) {

                    return times;
                }
            }
            return ["Unavailable"];
        },
        getTimeRange(time) {
            if(time.from) {
                return this.formatShortTime(time.from) + " - " + this.formatShortTime(time.to);
            }
            return false;
        },
    }
}
</script>
